import { addVeil, removeVeil } from "./utils";
const $suggestionsWrapper = $(".suggestions-wrapper");
const endpoint = $suggestionsWrapper.data("url");
const minChars = 3;
const searchInput = "input.search-field";

/**
 * Removes html data from input, the category IDs that should not be shown based on customer group
 * Gets hidden categories from DOM
 *
 * @param {string} response html data
 * @return {string} html data without hidden categories
 */
const filterOutCategories = function (response) {
    let categories = $(".group-hidden-categories").data("ids");
    if (!categories) {
        return response;
    }
    categories = categories.split("|");
    let $element = $("<div />").html(response);
    categories.forEach(ID => {
        $element.find(".category-suggestion[data-category-id='" + ID + "']").remove();
    });
    return $element.html();
};

/**
 * Process Ajax response for SearchServices-GetSuggestions
 *
 * @param {Object|string} response - Empty object literal if null response or string with rendered
 *                                   suggestions template contents
 */
const processResponse = (response) => {
    $.spinner().stop();

    if (typeof (response) !== "object") {
        response = filterOutCategories(response);

        $suggestionsWrapper.find(".no-results").addClass("d-none");
        $suggestionsWrapper.find(".suggestions-frame").empty().append(response).show();

        // Trigger screen reader by setting aria-describedby with the new suggestion message.
        const suggestionsList = $(".suggestions .item");
        if ($(suggestionsList).length) {
            $(searchInput).attr("aria-describedby", "search-result-count");
        } else {
            $(searchInput).removeAttr("aria-describedby");
            $suggestionsWrapper.find(".no-results").removeClass("d-none");
        }
    } else {
        $suggestionsWrapper.find(".suggestions-frame").hide();
        $suggestionsWrapper.find(".no-results").removeClass("d-none");
    }
};

/**
 * Retrieve suggestions
 *
 * @param {Object} scope - Search field DOM element
 */
const getSuggestions = (scope) => {
    if ($(scope).val().length >= minChars) {
        $.spinner().start();
        $.ajax({
            context: scope,
            url: endpoint + encodeURIComponent($(scope).val()),
            method: "GET",
            success: processResponse,
            error: function () {
                $.spinner().stop();
            }
        });
    } else {
        $(scope).siblings(".reset-button").removeClass("d-sm-block");
        $suggestionsWrapper.find(".suggestions-frame").empty();
        $suggestionsWrapper.find(".no-results").removeClass("d-none");
    }
};

/**
 * Open suggestions
 */
const openSuggestions = () => {
    const $searchExpanded = $(".search-expanded");

    addVeil();
    $searchExpanded.addClass("in").find(".search-field").focus();
    $suggestionsWrapper.find(".no-results");
};

/**
 * Close suggestions
 */
const closeSuggestions = () => {
    const $searchExpanded = $(".search-expanded");

    $searchExpanded.removeClass("in");
    removeVeil();
    $suggestionsWrapper.find(".suggestions-frame").empty();
};

/**
 * Show all articles
 */
const showAllArticles = () => {
    const activeTab = window.location.href.split("#")[1];

    if (activeTab === "content-search-results-pane") {
        const $activeTab = $("#articles-tab");
        const showMoreUrl = $activeTab.data("url");
        const $target = $("#content-search-results");
        $activeTab.tab("show");

        $.spinner().start();
        $.ajax({
            url: showMoreUrl,
            method: "GET",
            success: function (response) {
                $target.append(response);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
};

export default () => {
    const $body = $("body");
    const searchTrigger = ".js-search-trigger";
    const searchClose = ".js-search-close";

    $body.on("click", searchTrigger, (e) => {
        e.preventDefault();
        openSuggestions();
    });

    $body.on("click", searchClose, (e) => {
        e.preventDefault();
        closeSuggestions();
    });

    $(document).on("click", "#view-all-articles, #view-all-products", function() {
        const searchQuery = $("form[name='simpleSearch']").find(".search-field").val();
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const query = urlParams.get("q");

        if (searchQuery === query) {
            window.location.replace($(this).attr("href"));
            window.location.reload();
        }
    });

    $(document).ready(showAllArticles);

    $("form[name='simpleSearch']").submit((e) => {
        const suggestionsList = $(".suggestions .item");

        if (suggestionsList.filter(".selected").length !== 0) {
            e.preventDefault();
            suggestionsList.filter(".selected").find("a")[0].click();
        }
    });

    $(searchInput).each(function () {
        /**
         * Use debounce to avoid making an Ajax call on every single key press by waiting a few
         * hundred milliseconds before making the request. Without debounce, the user sees the
         * browser blink with every key press.
         */
        const debounceSuggestions = window.debounce(getSuggestions, 1500);

        $(this).on("input", function (e) {
            debounceSuggestions(this, e);
        });
    });
};
